<div class="dialog-overlay" (click)="onClose()">
  <div class="dialog-container" (click)="$event.stopPropagation()">
    <button class="dialog-close" (click)="onClose()" aria-label="Kapat">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 6L6 18M6 6l12 12"/>
      </svg>
    </button>
    
    <div class="dialog-header">
      <div class="dialog-icon" [class]="'icon-' + config.type">
        {{ getIcon() }}
      </div>
      <h2 class="dialog-title">{{ config.title }}</h2>
    </div>
    
    <div class="dialog-body">
      <p class="dialog-message">{{ config.message }}</p>
    </div>
    
    <div class="dialog-footer">
      <button 
        *ngIf="config.showCancel" 
        class="dialog-button dialog-button-cancel" 
        (click)="onCancel()">
        {{ config.cancelText }}
      </button>
      <button 
        class="dialog-button dialog-button-confirm" 
        [class]="'button-' + config.type"
        (click)="onConfirm()">
        {{ config.confirmText }}
      </button>
    </div>
  </div>
</div>


